export default __webpack_public_path__ + "static/media/thum_1.719d2f3e.png";